import React, { useEffect } from "react";
import HomeBanner from "../../assets/images/sangamam_1.jpg";
import Banner from "../../components/header/banner";
import SangamamLocation from "./locationsangamam";
import SangamamFeature from "./sangamamFeature";

import location from "../../assets/icons/features/location.png";
import hand from "../../assets/icons/features/hand.png";
import legal from "../../assets/icons/features/legal.png";
import money from "../../assets/icons/features/money.png";
import school from "../../assets/icons/features/school.png";
import water from "../../assets/icons/features/water.png";
import Aboutsangamam from "../../assets/images/card44.png";
import "./sangamam.css";
import { PlotsAdvantages } from "../../components/plots/plots";
import SliderVideo from "../../components/sliders/vsliders";
import { DownloadBrochure } from "../../components/download_brochure/download_brochure";
import BookVisitButton from "./bookVisitButton";
import SangamamMap from "./sangamamMap";
import {
  HeroHighlights,
  WhyInvestThiruporur,
  PremiumAmenities,
  LocationAdvantages,
  PlotSpecs,
  SangamamFAQ,
  ClosingCTA,
} from "./sangamamContent";

/**
 * @author
 * @function sangamam
 **/

export const Sangamam = (props) => {
  useEffect(() => {
    document.title = "Premium Residential Villa Plots sale in Thiruporur Omr";

    // Optional: restore default title when user navigates away
    return () => {
      document.title = "Anandhamplots";
    };
  }, []);
  // Fixed: previously had 12 entries (the same 6 duplicated twice).
  // Now 6 unique cards matching the "Project Highlights" copy.
  const featureDetails = [
    {
      id: 1,
      imgSrc: location,
      imgText: "location",
      title:
        "Prime Highway Location — excellent access to OMR, ECR and GST Road.",
    },
    {
      id: 2,
      imgSrc: hand,
      imgText: "hand",
      title:
        "Double Side Road Access for better accessibility and long-term value.",
    },
    {
      id: 3,
      imgSrc: legal,
      imgText: "legal",
      title: "DTCP Approved Layout with transparent documentation.",
    },
    {
      id: 4,
      imgSrc: money,
      imgText: "money",
      title: "Ready-to-Build Villa Plots — start building right away.",
    },
    {
      id: 5,
      imgSrc: water,
      imgText: "water",
      title: "Premium Gated Community with quality infrastructure.",
    },
    {
      id: 6,
      imgSrc: school,
      imgText: "school",
      title:
        "High Appreciation Potential — surrounded by IT parks and industries.",
    },
  ];
  return (
    <div>
      <BookVisitButton />
      <Banner bannerImgSrc={HomeBanner} />
      <HeroHighlights />
      <Whysangamam />
      <WhyInvestThiruporur />
      <h2 className="sangamam-features-heading green-text heading-bold">
        Project Highlights
      </h2>
      <SangamamFeature details={featureDetails} />
      <PremiumAmenities />
      <LocationAdvantages />
      <h2 className="sangamam-features-heading green-text heading-bold">
        Promising Locations
      </h2>
      <SangamamLocation />
      <SangamamMap />
      <PlotSpecs />
      <PlotsAdvantages />
      <SangamamFAQ />
      <SliderVideo />
      <ClosingCTA />
    </div>
  );
};

const Whysangamam = () => {
  return (
    <div className="why-sangamam">
      <img src={Aboutsangamam} alt="About sangamam" />
      <div className="sangamam-why-content">
        <h4>Why Pon Anandham Sangamam?</h4>
        <p>
          Welcome to Pon Anandham Sangamam, a premium DTCP-approved villa
          plotted community strategically located on the Thiruporur-
          Chengalpattu 4-lane Highway. With excellent connectivity to OMR, ECR,
          GST Road, and key IT and industrial hubs such as Siruseri SIPCOT and
          OneHub Chennai, the project offers the perfect balance of
          connectivity, convenience, and long-term investment potential.
        </p>
        <p>
          Situated near the 1,450-acre OneHub Chennai Japanese Industrial
          Township, home to global companies like Yamaha and Hitachi, Pon
          Anandham Sangamam is positioned in one of South Chennai's
          fastest-growing investment corridors. With continuous infrastructure
          development and increasing residential demand, the project offers
          excellent long-term appreciation potential, making it an ideal choice
          for both homebuyers and investors.
        </p>
        <p>
          Designed for comfortable and secure living, Pon Anandham Sangamam
          features wide blacktop roads, landscaped parks, LED street lighting,
          CCTV surveillance, dedicated water supply, and premium infrastructure.
          Whether you're building your dream home or making a smart investment,
          it offers the perfect blend of connectivity, lifestyle, and long-term
          appreciation.
        </p>
        <div className="sangamam-broucher-btn-div">
          <DownloadBrochure />
        </div>
      </div>
    </div>
  );
};
